import {createLoaderWorker} from '@loaders.gl/loader-utils';
import {CompressedTextureLoader} from '../compressed-texture-loader';

createLoaderWorker(CompressedTextureLoader);
